import { render, staticRenderFns } from "./InitialProposalTable.vue?vue&type=template&id=e36b4ed6"
import script from "./InitialProposalTable.vue?vue&type=script&lang=js"
export * from "./InitialProposalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports